// https://developer.mozilla.org/en-US/docs/Web/API/document
if (!('HTMLDocument' in window)) {
  window.HTMLDocument = window.Document;
}



//////////////////
// WEBPACK FOOTER
// ./~/dom-shims/shim/HTMLDocument.js
// module id = 342
// module chunks = 0